<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Sổ ghi đầu bài" :link="[{ text: 'Sổ ghi đầu bài', href: '/teacherClassNotes' }]" />
    </div>

    <v-card class="ma-4">
      <!-- <v-row class="d-flex">
        <v-col class="pa-6 px-8" cols="12"> -->
      <v-row class="pl-4">
        <v-col cols="12" md="2" class="">
          <div>Ngày</div>
          <h3>{{ date | ddmmyyyy }}</h3>
        </v-col>
        <v-col cols="12" md="2" class="">
          <div>Thứ</div>
          <h3>{{ slot.day | scheduleDay }}</h3>
        </v-col>
        <v-col cols="12" md="2" class="">
          <div>Tiết</div>
          <h3>{{ slot.index }}</h3>
        </v-col>
        <v-col cols="12" md="2" class="">
          <div>Lớp</div>
          <h3>{{ slot | _get('class.title') }}</h3>
        </v-col>
        <v-col cols="12" md="2" class="">
          <div>Sĩ số</div>
          <h3>{{ studentClassCount }}</h3>
        </v-col>
        <v-col cols="12" md="2" class="">
          <div>Môn học</div>
          <h3 v-if="$_get(slot, 'classNote.subject.title')">
            <!-- đã ghi vào lịch sử -->
            {{ slot | _get('classNote.subject.title') }}
          </h3>
          <h3 v-else>
            <!-- chưa ghi  -->
            {{ slot | _get('subject.title') }}
          </h3>
        </v-col>
      </v-row>
      <!-- </v-col>
      </v-row> -->
    </v-card>
    <ClassNoteTabs class="mt-8 mx-4" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ClassNoteTabs from '@/modules/classNote/teacherSide/ClassNoteTabs.vue'

export default {
  components: {
    Breadcrumbs,
    ClassNoteTabs,
  },
  data() {
    return {
      time: moment().toISOString(),
      subjectGroup: '',
      selectedTeacherId: '',
      loading: false,
      slots: [],
    }
  },
  watch: {},
  computed: {
    ...mapState('ClassNoteDetail', ['slot', 'date', 'studentClassCount']),
    ...mapGetters('auth', ['profile']),
  },
  async created() {
    const slotId = this.$route.params.id
    const date = this.$route.params.date
    if (!moment(date, moment.ISO_8601, true).isValid()) this.$router.replace('/teacherClassNotes')

    this.setDate(date)
    await this.fetchData({ slotId })
  },
  methods: {
    ...mapActions('ClassNoteDetail', ['fetchData', 'setDate']),
  },
}
</script>
